import './Signin.css';
import React, { useRef, useEffect } from "react";
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from "react-router-dom";
import { connect } from 'react-redux';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LinkMui from '@mui/material/Link';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';

import {
    ValidateEmail,
    ValidatePassword
} from '../../../libraries/Tool';

import {
    Signin as SigninUser,
} from '../../../services/Auth.service';

function Signin(props) {
    const { translate, UserInfor, SnackbarAlert } = props;
    const navigate = useNavigate();
    const typingTimeoutRef = useRef(null);
    const [email, setEmail] = React.useState();
    const [emailInvalid, setEmailInvalid] = React.useState(false);
    const [password, setPassword] = React.useState();
    const [passwordInvalid, setPasswordInvalid] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleOnChangeEmail = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setEmail(e.target.value);
            setEmailInvalid(!ValidateEmail(e.target.value));
        },500)
    }

    const handleOnChangePassword = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setPassword(e.target.value);
            setPasswordInvalid(!ValidatePassword(e.target.value));
        },500)
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const onClickSignIn = async (e) => {
        let event;
        e.preventDefault();
        if(!email) setEmailInvalid(true);
        if(!password) setPasswordInvalid(true);
        if(
            email &&
            password &&
            !emailInvalid &&
            !passwordInvalid
        ) {
            event = SigninUser({
                email
                ,password
            });
            event?.then(res => {
                if(res?.data?.passwordUpdateIs){
                    navigate(`/password-expired/${res?.data?.token}`)
                } else {
                    localStorage.setItem('_userinfor', JSON.stringify(res?.data?.userInfor));
                    props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: res?.data?.userInfor });
                    navigate(`/control-center/dashboard`);
                }
            })
            .catch(err => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            })
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div>
            <Container maxWidth="md" sx={{ my: 20 }}>
                <Typography variant="h4" gutterBottom component="div" sx={{ fontWeight: "bold" }}>
                    {translate('signintoocto', {name: 'RPA CLOUD'})}
                </Typography>
                <Typography variant="h6" gutterBottom component="div" sx={{ color: "#586978", fontWeight: "bold", mb: "3em" }}>
                    {translate('welcomeback') + ' ' + translate('pleasesignin')}
                </Typography>
                <Box 
                    component="form"
                    sx={{
                        '& > :not(style)': { my: 1 },
                      }}
                    noValidate
                    className="login-box-main"
                    onSubmit={onClickSignIn}
                >
                    <TextField 
                        autoFocus
                        fullWidth
                        type="email"
                        id="email" 
                        variant="outlined"
                        label={translate('email')}
                        autoComplete="username"
                        sx={{ backgroundColor: "#fff" }}
                        onChange={handleOnChangeEmail}
                        error={
                            emailInvalid
                        }
                        helperText={
                            (emailInvalid) ? translate('pleaseenteravalidemailaddress') :
                            ""
                        }
                    />
                    <FormControl required fullWidth variant="outlined">
                        <InputLabel error={passwordInvalid}>{translate('password')}</InputLabel>
                        <OutlinedInput
                            fullWidth
                            id="password" 
                            variant="outlined"
                            label={translate('password')}
                            type={showPassword ? 'text' : 'password'}
                            autoComplete="current-password"
                            sx={{ backgroundColor: "#fff" }}
                            onChange={handleOnChangePassword}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowPassword(!showPassword) }
                                        onMouseDown={(event) =>  event.preventDefault() }
                                        edge="end"
                                        size='small'
                                    >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            error={
                                passwordInvalid
                            }
                        />
                        {passwordInvalid && (
                        <FormHelperText error id="password">
                        {(passwordInvalid) ? translate('pleaseenteravalidpassword') : ""}
                        </FormHelperText>)}
                    </FormControl>
                    <Button 
                        fullWidth
                        variant="contained" 
                        color="primary" 
                        disableElevation
                        type="submit"
                        onClick={onClickSignIn}
                        disabled={!email || emailInvalid || !password || passwordInvalid}
                    >
                    {translate('signin')}
                    </Button>
                </Box>
                <Box className='login-box-sub'>
                    <LinkMui color="inherit" component={Link} underline="none" to="/forgot-password">{translate('forgotyourpassword')}</LinkMui>
                    {/* <br></br>
                    <br></br>
                    <LinkMui underline="none" component={Link} to="/register/standard">{translate('registernow')}</LinkMui> */}
                </Box>
            </Container>
        </div>
    )
}
function mapStateToProps(state) {
    return {
      UserInfor: state.UserInfor,
      SnackbarAlert: state.SnackbarAlert,
    }
}
export default connect(mapStateToProps)(withTranslate(Signin));
